import _ from 'lodash';

export function hasPluginWithKey(editor, key) {
  return editor && _.some(editor.plugins, p => p.key === key);
}
